import React, { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { tOSViewStateAtom } from '../../atoms';
import './ErrorPanel.css';
import { BsX } from 'react-icons/bs';

type ErrorPanelProps = {
    dataErrorMessage: string[] | undefined;
    setDataErrorMessage: (value: string[] | undefined) => void;
}

const ErrorPanel: React.FC<ErrorPanelProps> = ({ dataErrorMessage, setDataErrorMessage }) => {
    const tOSViewState = useAtomValue(tOSViewStateAtom);

    useEffect(() => {
        if (dataErrorMessage && tOSViewState.includes('closed')) {
            const timer = setTimeout(() => {
                setDataErrorMessage(undefined);
            }, 4000);

            // クリーンアップ関数でタイマーをクリア
            return () => clearTimeout(timer);
        }
    }, [dataErrorMessage, setDataErrorMessage, tOSViewState]);


    if (!dataErrorMessage) { return <></> };

    return (
        <div className="error-panel-container">
            <div className='error-panel-header'>
                {/* <h2>表示エラー</h2> */}
                <BsX onClick={ () => setDataErrorMessage(undefined) } className='closeBtn' />
            </div>
            <ul>
                {dataErrorMessage?.map((msg, index) => {
                    return (<li key={index}>{msg}</li>);
                })}
            </ul>
        </div>
    );
};

export default ErrorPanel;
